import { ViewportContext } from '../../../context/corporatiu/ViewportProvider';
import { useContext } from 'react';

export const useViewport = () => {
    const { viewport, isMobile, isOnlyMobile, isMobileDevice, zoomNavigator, typesViewport } = useContext(ViewportContext) || {};
    return {
        viewport,
        isMobile,
        isOnlyMobile,
        isMobileDevice,
        zoomNavigator,
        typesViewport
    };
};
